import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HighlightMatchPipe } from './highlight-match.shared.pipe';
@NgModule({
    declarations: [HighlightMatchPipe],
    exports: [ HighlightMatchPipe],
})


export class HighlightMatchPipeModule {}
